import { East } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { theme } from "src/assets/theme";
import { Paths } from "src/constants/paths";
import WhiteCard from "src/shared/components/WhiteCard";
import Breakdown from "./components/Breakdown";
import PlanInfo from "./components/PlanInfo";
import { useSubscription } from "src/context/SubscriptionProvider";
import CancellationFooter from "../CancellationFooter";
import { useCallback } from "react";
import { useUpdateVisit } from "src/hooks/useUpdateVisit";

const Review = () => {
  const { t } = useTranslation();
  const page = "cancellationReview";
  const subscriptionId = useSubscription((s) => s.id);
  const navigate = useNavigate();
  const updateVisit = useUpdateVisit();

  const handleRefuse = useCallback(() => {
    updateVisit({
      canceled_at: new Date().toISOString(),
      status: "canceled",
    });

    return navigate(
      `${Paths.MY_ACCOUNT}/${Paths.MY_SUBSCRIPTIONS}/${subscriptionId}`
    );
  }, [navigate, subscriptionId, updateVisit]);

  return (
    <Stack gap={2}>
      <PlanInfo />
      <WhiteCard direction={"row"} justifyContent={"space-between"}>
        <Typography>{t(`${page}.changeMind`, "Change your mind?")}</Typography>
        <Stack
          direction={"row"}
          color={theme.palette.primary.main}
          alignItems={"center"}
          gap={1}
          sx={{ cursor: "pointer" }}
        >
          <Link
            color={theme.palette.primary.main}
            to={`${Paths.MY_ACCOUNT}/${Paths.MY_SUBSCRIPTIONS}/${subscriptionId}`}
          >
            {t(`${page}.backToSubscription`, "Back to subscription")}
          </Link>
          <East fontSize="small" />
        </Stack>
      </WhiteCard>
      <Breakdown />
      <CancellationFooter
        refuseText={t(`subscriptions.cancel.button.nevermind`)}
        continueText={t(`button.confirm`)}
        question={`1CixX4jj`}
        onRefuse={handleRefuse}
      />
    </Stack>
  );
};

export default Review;
